import useSWR from "swr";
import { customFetcher, customFetcherNative } from "../../../../utils";
import VirtualTable from "../../../custom/VirtualTable";
import { apiClientEosNative } from "../../../../apiClient";
import useUnit from "../../../../customHooks/useUnit";
import moment from "moment";
import { useMemo, useState } from "react";
import { FormGroup } from "reactstrap";
import { Label } from "reactstrap";
import { Input } from "reactstrap";
import styled from "styled-components";
import _ from "lodash";
import ModalFlightManifest from "../../breakdownInstructions/ModalFlightManifest";
import useUser from "../../../../customHooks/useUser";
import useModal from "../../../../customHooks/useModal";
import { IFFM } from "../../../../globals/interfaces";

export interface ITransferExportLog {
    createdBy: string;
    createdAt: string;
    awbUld: string;
    pieces: number;
    type: string;
    scannedLocation: string;
    truck: string;
}

interface Truck {
    truck: string;
}

export default function Log() {

    const { user } = useUser();
    const unit = user.s_unit;
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [s_flight_id, set_s_flight_id] = useState<string>();
    const { modal: modalFlightManifest, setModal: setModalFlightManifest } = useModal();

    const {
        data
    } = useSWR(`/truck-buildup/export?unit=${unit}&date=${date}`, customFetcherNative<IFFM>, {
        fallbackData: []
    });

    const viewImportFlightManifest = (s_flight_id: string) => {
        set_s_flight_id(s_flight_id);
        setModalFlightManifest(true);
    }

    return (
        <Container>
            <FormGroup>
                <Label>Date</Label>
                <CustomDate type={'date'} value={date} onChange={e => setDate(e.target.value)} />
            </FormGroup>
            <FlexContainer>
                <div>
                    <Label>Select Truck</Label>
                    <VirtualTable<IFFM>
                        data={data}
                        mapping={[{
                            name: 'Truck/Flight',
                            value: 's_flight_id'
                        }]}
                        numRows={10}
                        handleClick={item => viewImportFlightManifest(item.s_flight_id)}
                    />
                </div>
            </FlexContainer>
            <ModalFlightManifest 
                modal={modalFlightManifest}
                setModal={setModalFlightManifest}
                s_flight_id={s_flight_id}
                d_arrival_date={date}
                user={user}
            />
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
`;

const CustomDate = styled(Input)`
    width: 200px;
`;

const FlexContainer = styled.div`
    display: flex;
    gap: 10px;
    flex: 1;

    & div:nth-child(2) {
        flex: 1;
    }
`;